import { OrderNumQuotaCodeComboBoxComponent } from './order-num-quota-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { OrderNumQuota } from './order-num-quota.model';

/**
 * 注文コード割当コードコンボボックスモデル
 *
 * @export OrderNumQuotaCodeComboBoxModel
 * @class OrderNumQuotaCodeComboBoxModel
 */
export class OrderNumQuotaCodeComboBoxModel {

  // 注文コード割当コードリスト
  public orderNumQuotaList: OrderNumQuota[] = null;
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // 初期設定コード値
  public setOrderNumQuotaCode: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // コンボボックスインスタンス
  public component: OrderNumQuotaCodeComboBoxComponent = null;
  // 受注コード(voの値)
  public orderCode: string = <string>'';
  // 媒体区分(voの値)
  public mediumType: string = <string>'';
  // Ｗ掲載フラグ(voの値)
  public multiPublishFlg: string = <string>'';


  /**
   * 注文コード割当一覧を更新する
   *
   * @param {*} serverData 注文コード割当一覧のサーバ取得データ
   * @memberof OrderNumQuotaCodeComboBoxModel
   */
  public updateOrderNumQuotaList(serverData: OrderNumQuota[]): void {
    let tempOrderNumQuotaList: OrderNumQuota[] = [];

    if (serverData !== null) {
      tempOrderNumQuotaList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempOrderNumQuotaList)) {
        tempOrderNumQuotaList = [];
      }
    }

    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob: OrderNumQuota = new OrderNumQuota();
      tempOrderNumQuotaList.splice(index, 0, ob);
      index = 1;
    }

    // コード + ： + 名称追加
    for (; index < tempOrderNumQuotaList.length; index++) {
      tempOrderNumQuotaList[index].OrderNumQuotaCodeName =
        tempOrderNumQuotaList[index].OrderNumQuotaCode + ':' + tempOrderNumQuotaList[index].OrderNumQuotaName;
    }

    this.orderNumQuotaList = tempOrderNumQuotaList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedOrderNumQuotaCode();
  }

}
